<template>
  <symbol
    id="pin-spot-restroom-female"
    viewBox="0 0 60 67.904"
  >
    <g transform="translate(-704.576 -219.32)">
      <path
        d="M764.576,249.319a30,30,0,0,0-29.7-30,30.325,30.325,0,0,0-30.3,29.783,30.008,30.008,0,0,0,19.4,28.286,15.218,15.218,0,0,1,5.766,3.932,62.331,62.331,0,0,1,4.32,5.616.688.688,0,0,0,1.086.037c1.684-2.008,3.411-4.3,5.176-6.134a15.393,15.393,0,0,1,5.357-3.646,30.008,30.008,0,0,0,18.9-27.877"
        transform="translate(0 0)"
      />
      <path
        d="M735.86,234.315a4.111,4.111,0,1,1-4.111-4.111,4.112,4.112,0,0,1,4.111,4.111"
        transform="translate(2.828 1.334)"
        fill="#fff"
      />
      <path
        d="M736.784,246.966H726.9v-4.755a4.944,4.944,0,1,1,9.889,0Z"
        transform="translate(2.736 2.2)"
        fill="#fff"
      />
      <path
        d="M739.347,254.334H724.836l2.323-9.635h9.867Z"
        transform="translate(2.484 3.112)"
        fill="#fff"
      />
      <path
        d="M729.8,264.187h0a1.4,1.4,0,0,1-1.4-1.4V250.459h2.805v12.325a1.4,1.4,0,0,1-1.4,1.4"
        transform="translate(2.921 3.818)"
        fill="#fff"
      />
      <path
        d="M733.1,264.187h0a1.4,1.4,0,0,1-1.4-1.4V250.459h2.805v12.325a1.4,1.4,0,0,1-1.4,1.4"
        transform="translate(3.326 3.818)"
        fill="#fff"
      />
    </g>
  </symbol>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// restroom_female.vue?4c9a0cc5